/** Auditoria: quem fez o quê, quando. Supervisor e admin. */
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Fragment, useState } from 'react';
import type { AuditoriaResposta } from '@sgc/contracts';
import { get } from '../lib/api';
import { useAuth } from '../lib/auth';
import { fmtDataHora, useMembros } from '../lib/tarefas';
import { Campo, Sel } from '../ui/campos';
import { Sec } from '../ui/layout';

export const Route = createFileRoute('/_app/auditoria')({ component: Auditoria });

function Auditoria() {
  const { eu } = useAuth();
  const papel = eu?.escritorio?.papel;
  const pode = papel === 'ADMIN' || papel === 'SUPERVISOR';
  const membros = useMembros();
  const [f, setF] = useState({ de: '', ate: '', entidade: '', busca: '', usuarioId: '', page: 1 });
  const set = (p: Partial<typeof f>) => setF((x) => ({ ...x, ...p, page: p.page ?? 1 }));
  const q = useQuery({ queryKey: ['auditoria', f], queryFn: () => get<AuditoriaResposta>('/v1/auditoria', { ...f, perPage: 100 }), enabled: pode, placeholderData: (p) => p });
  const r = q.data;
  const [aberto, setAberto] = useState<string | null>(null);
  const json = (v: unknown) => (v == null ? '' : JSON.stringify(v, null, 1).replace(/[{}\n"]/g, '').replace(/,\s*/g, ' · ').trim());
  if (!pode) return <><div className="topbar"><div><h1>Auditoria</h1></div></div><div className="conteudo"><div className="alerta info">só supervisor e administrador consultam a auditoria</div></div></>;
  return (
    <>
      <div className="topbar"><div><h1>Auditoria</h1><div className="sub">{r ? `${r.total} registro(s)` : ''}</div></div></div>
      <div className="conteudo">
        <Sec titulo="Filtros">
          <div className="fgrid">
            <Campo className="c2" rotulo="De" type="date" valor={f.de} onChange={(v) => set({ de: v })} />
            <Campo className="c2" rotulo="Até" type="date" valor={f.ate} onChange={(v) => set({ ate: v })} />
            <Sel className="c2" rotulo="Entidade" valor={f.entidade} vazio="todas" opcoes={(r?.entidades ?? []).map((e) => [e, e] as const)} onChange={(v) => set({ entidade: v })} />
            <Sel className="c3" rotulo="Quem" valor={f.usuarioId} vazio="todos" opcoes={(membros.data ?? []).map((m) => [m.usuarioId, m.nome] as const)} onChange={(v) => set({ usuarioId: v })} />
            <Campo className="c3" rotulo="Busca" valor={f.busca} onChange={(v) => set({ busca: v })} placeholder="descrição ou id" />
          </div>
        </Sec>
        <div className="tbwrap">
          <table className="tb compacta">
            <thead><tr><th>Quando</th><th>Quem</th><th>Ação</th><th>Entidade</th><th>Descrição</th><th>IP</th></tr></thead>
            <tbody>
              {r?.itens.length === 0 && <tr><td className="vazio" colSpan={6}>nada registrado com esse filtro</td></tr>}
              {r?.itens.map((i) => (
                <Fragment key={i.id}>
                  <tr onClick={() => setAberto(aberto === i.id ? null : i.id)} style={{ cursor: i.antes || i.depois ? 'pointer' : undefined }}>
                    <td className="mono">{fmtDataHora(i.quando)}</td><td>{i.usuarioNome ?? <span className="dim">sistema</span>}</td><td className="mono">{i.acao}</td><td className="mono dim">{i.entidade}</td>
                    <td>{i.descricao}{(i.antes || i.depois) ? <span className="dim"> {aberto === i.id ? '▴' : '▾'}</span> : null}</td><td className="mono dim">{i.ip}</td>
                  </tr>
                  {aberto === i.id && (i.antes || i.depois) ? <tr><td colSpan={6} className="mini">{i.antes ? <div><b>antes:</b> {json(i.antes)}</div> : null}{i.depois ? <div><b>depois:</b> {json(i.depois)}</div> : null}</td></tr> : null}
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>
        {r && r.total > r.perPage && (
          <div className="linha-acoes">
            <button className="btn mini" type="button" disabled={f.page <= 1} onClick={() => set({ page: f.page - 1 })}>‹</button>
            <span className="mini">página {f.page} de {Math.ceil(r.total / r.perPage)}</span>
            <button className="btn mini" type="button" disabled={f.page * r.perPage >= r.total} onClick={() => set({ page: f.page + 1 })}>›</button>
          </div>
        )}
      </div>
    </>
  );
}
